import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=15759d8e&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=tsx&"
export * from "./Action.vue?vue&type=script&lang=tsx&"
import style0 from "./Action.vue?vue&type=style&index=0&id=15759d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15759d8e",
  null
  
)

export default component.exports